import React from 'react';
import sorryKidPath from 'assets/photo/letter-number-formations/sorry-kid.png';
import { translate } from 'translations/translator';
const t = (key) => translate('lnf', key);

function MissingLicensePage() {
  function handleClose() {
    window.close();
  }

  return (
    <section className='missing-license-page'>
      <img alt='oops' src={sorryKidPath} />
      <div>
        <span>{t('403error')}</span>
        <h1>{t('accessForbidden')}</h1>
        <h2>{t('doNotHaveAccess')}</h2>
        <button onClick={handleClose}>{t('close')}</button>
      </div>
    </section>
  );
}

export default MissingLicensePage;
